import "./footerCta.css";

const FooterCta = () => {
  return (
    <div className="footerCta">
      <div className="footerCta__container">
        <h3 className="home-headers">Gain the edge with QR Codes</h3>
        <p>Dynamic, Customizable QR Codes with Scan Tracking & Analytics</p>
        <button className="home-cta-btn">Get Started for Free</button>
      </div>
    </div>
  );
};

export default FooterCta;
